module.exports = __webpack_public_path__ + "d3ec9b01ee6d0828fc8fe4b1298c386a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/princeton_university_2_2023_chart.png
// module id = 1720
// module chunks = 0